import type { RailLayout } from "@/data/rail-branches";
import type { SceneBeat } from "./layoutBeat";

export function acquisitionsOf(beats: readonly SceneBeat[]): { acquisitions?: RailLayout["acquisitions"] } {
  const acquisitions = beats.flatMap((beat) => (beat.acquires ?? []).map((item) => ({
    characterId: item.characterId,
    fromCharacterId: item.fromCharacterId,
    startMs: beat.startMs,
    endMs: beat.endMs,
  })));
  return acquisitions.length === 0 ? {} : { acquisitions };
}

/** One visit across back-to-back scenes, so they stay beside the vehicle throughout. */
export function visitsOf(beats: readonly SceneBeat[]): { visits?: RailLayout["visits"] } {
  const visits: NonNullable<RailLayout["visits"]> = [];
  for (const beat of beats) {
    for (const { characterId, vehicleId } of beat.visits ?? []) {
      const open = visits.find((item) => (
        item.characterId === characterId
        && item.vehicleId === vehicleId
        && item.endMs === beat.startMs
      ));
      if (open === undefined) {
        visits.push({ characterId, vehicleId, startMs: beat.startMs, endMs: beat.endMs });
      } else {
        open.endMs = beat.endMs;
      }
    }
  }
  return visits.length === 0 ? {} : { visits };
}

/** The vehicle someone was riding in the scene just before this stay of theirs starts. */
export function steppedOutOf(
  beats: readonly SceneBeat[],
  stay: { characterId: string; startMs: number },
): string | undefined {
  return beats.find((beat) => beat.endMs === stay.startMs)?.aboard
    ?.find((ride) => ride.characterId === stay.characterId)?.vehicleId;
}
